import { render, staticRenderFns } from "./ObiSelect.vue?vue&type=template&id=18c4f580&scoped=true&"
import script from "./ObiSelect.vue?vue&type=script&lang=js&"
export * from "./ObiSelect.vue?vue&type=script&lang=js&"
import style0 from "./ObiSelect.vue?vue&type=style&index=0&id=18c4f580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c4f580",
  null
  
)

export default component.exports